<template >
  <div class="sectionDialog">
    <el-dialog :title="title" :visible.sync="sectionDialogVisible" width="500px" :close-on-click-modal="false">
      <el-form ref="sectionForm" :model="sectionForm"  label-width="140px" :rules="rules">
        <el-form-item label="章节名称"  class="is-required" prop="name" >
          <el-input v-model="sectionForm.name" :maxlength="200"> </el-input>
        </el-form-item>
        <el-form-item label="排序值"  class="is-required" prop="ordinal">
          <el-input v-model.trim="sectionForm.ordinal" placeholder="请输入排序值..." maxlength="9"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="sectionDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="save()" v-loading="loading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
import booknodeService from '@/service/booknodeService'
export default {
  props: {
    id: {
      type: Number
    },
    rowData: Object,
    value: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      title: '编辑知识点',
      loading: false,
      sectionForm: {
        name: '',
        ordinal: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入章节名称', trigger: ['blur', 'change']}
        ],
        ordinal: [
          {required: true, message: '请输入序列号', trigger: 'blur'},
          {pattern: /^[0-9]*$/, message: '请输入数字', trigger: ['blur', 'change']}
        ]
      }
    }
  },
  methods: {
    save () {
      this.loading = true
      this.$refs.sectionForm.validate(async valid => {
        // 验证通过
        if (valid) {
          // try {
          //   let data = booknodeService.save(this.sectionForm)
          //   // @success
          //   this.$emit('success', this.sectionForm.name)
          //   this.loading = false
          //   this.sectionDialogVisible = false
          // } catch (e) {
          //   this.loading = false
          //   this.$message.error(e && e.msg)
          // }
          this.sectionForm.name = this.sectionForm.name.trim()
          booknodeService
            .zgkSave(this.sectionForm)
            .then(resp => {
              this.$emit('success', this.sectionForm.name)
              this.loading = false
              this.sectionDialogVisible = false
            })
            .catch(e => {
              this.loading = false
              this.$message.error(e && e.msg)
            })
        }
        this.loading = false
      })
    }
  },
  watch: {
    sectionDialogVisible (newVal, oldVal) {
      this.title = '新增'
      if (newVal) {
        if (this.$refs.sectionForm) {
          this.$refs.sectionForm.resetFields()
        }
        // 加载初始化数据
        this.sectionForm = {
          id: this.$props.rowData.id,
          ordinal: this.$props.rowData.ordinal,
          subjectId: this.$props.rowData.subjectId,
          columnId: this.$props.rowData.columnId,
          name: this.$props.rowData.name,
          parentId: this.$props.rowData.parentId,
          type: 'REAL'
        }
        this.title = '编辑章节'
      }
    }
  },
  computed: {
    sectionDialogVisible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style scoped>
  .sectionDialog .el-form-item .el-input{
    width:75%;
  }
</style>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/pages/layout/section-manage/edit-dialog/exam.vue